import styled, { css } from "styled-components";

import { COLOR_VALUES } from "shared/config/colors";
import HStack from "shared/components/layout/stack/HStack";
import { mediaQueries } from "shared/config/breakpoints";

export const StyledTimesheetControl = styled(HStack)`
    justify-content: flex-end;
    align-items: center;
    padding: 0px;
    gap: 32px;

    ${mediaQueries.small} {
        justify-content: flex-start;
        align-items: center;
        gap: 0;
    }
`;

export const ResponsiveTotalContainer = styled.div`
    ${mediaQueries.small} {
        display: flex;
        flex-direction: row;
        gap: 4px;
        flex: 0 0 auto;
        align-items: center;
    }
`;

export const ExpandCollapseContainer = styled(HStack)`
    button {
        border: 1px solid ${COLOR_VALUES.Gray_3};
        border-radius: 4px;
    }

    ${mediaQueries.small} {
        button {
            font-size: 0.7rem;
            padding: 1px 3px;
            min-height: 26px;
        }
    }
`;

export const ResponsiveButtonContainer = styled(HStack)`
    ${mediaQueries.small} {
        flex-shrink: 0;

        button {
            font-size: 0.75rem;
            padding: 6px 12px;
            min-height: 32px;
            white-space: nowrap;
        }
    }

    ${({ $isStuck }) =>
        $isStuck &&
        css`
            button {
                font-size: 0.75rem;
                padding: 4px 12px;
                min-height: 28px;
            }
        `}
`;
